export const feedbackCommentEditorAdapterBindings = {
    className: "<?",
    content: "<?",
    label: "<",
    onChange: "<",
    placeholder: "<?",
    statements: "<",
    datahook: "<"
};
